<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-02-25 13:35:54
 * @FilePath: /mrc-ess-fronted/src/Page/EssAdmin/Roster/RosterFormRecord/newRosterFormRecord.vue
 -->
<template>
  <ContentLayout>
    <template v-slot:page-nav>
      <ConentNav
        title="New "
        iSSelectLang
        cancelBtn
        submitBtn
        @submit="toNew"
        @cancel="toBack"
      />
    </template>
    <template v-slot:page-content>
      <v-card
        hover
        class="elevation-0 pa-0 transparent ma-auto max-1000 fill-height"
      >
        <v-card-text class="pa-0 from_content white"></v-card-text>
      </v-card>
    </template>
  </ContentLayout>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      iSEdited: false,
      showDelete: false,
    };
  },
  methods: {
    toBack: function () {
      this.$router.back();
    },

    toNew: function () {},
    toSave: function () {},
    toDelete: function () {},
  },
};
</script>